import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { advisorView } from 'Context/ViewContext';
import { Notes as SectionKey } from 'Consts/Questionnaire';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import Section from '../Section';
import FieldList from '../Fields/FieldList';
import TextareaInput from '../Fields/TextareaInput';
import BoolInput from '../Fields/BoolInput';
import RadioInput from '../Fields/RadioInput';

const numberPreviewChars = 90;

// TODO : NH - should instead update RadioInput to pass display text to onChangeType
const camelToSentence = (textCamel) => {
  const t = textCamel
    .split(/(?=[A-Z])/)
    .join(' ')
    .trim();
  return t.charAt(0).toUpperCase() + t.slice(1);
};

class NoteList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      content: '',
      type: '',
    };

    this.onChangeContent = this.onChange.bind(this);
    this.getNoteTitle = this.getNoteTitle.bind(this);
    this.onChangeType = this.onChange.bind(this);
  }

  onChange(name, value) {
    this.setState({ [name]: value });
  }

  getNoteTitle() {
    const { content, type: t } = this.state;
    if (t) {
      return camelToSentence(t);
    }
    const c = content || '';
    const suffix = c && c.length > numberPreviewChars ? '...' : '';
    const preview = c ? c.substr(0, numberPreviewChars).trim() + suffix : '';
    return preview || 'New Note';
  }

  render() {
    const {
      getNoteTitle,
      onChangeType,
      onChangeContent,
      props: { id, children: removeButton, expanded },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.15}
        title={getNoteTitle()}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <RadioInput
          placeholder="Note Type"
          name={`type.${id}`}
          label="Categories"
          answerKey="additionalNoteType"
          onChange={(name, value) => onChangeType('type', value)}
          options={[
            {
              id: 'general',
              text: 'General',
            },
            {
              id: 'accountInfo',
              text: 'Account Info',
            },
            {
              id: 'teamCoach',
              text: 'Team Coach',
            },
            {
              id: 'other',
              text: 'Other',
            },
          ]}
        />
        <TextareaInput
          placeholder="Note"
          name={`content.${id}`}
          answerKey="additionalNoteContent"
          onChange={onChangeContent}
        />
        <BoolInput
          label="Show in aggregate?"
          name={`showInAggregate.${id}`}
          answerKey="additionalNoteShowInAggregate"
        />
      </LabeledVerticalExpander>
    );
  }
}

NoteList.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
};

NoteList.defaultProps = {
  expanded: false,
};

const Notes = () => (
  <Section
    requiredView={advisorView}
    transitionSpeed={0.25}
    height={400}
    title="Additional Notes"
    expanded
    sectionKey={SectionKey}
  >
    <FieldList
      requiredView={advisorView}
      addLabel="Add a Note"
      keyPrefix="additionalNotes"
      Of={NoteList}
      label="Notes"
    />
  </Section>
);

export default Notes;
